import ApiService from '@/services/api.js'

/**
 * @param   {Store}         context
 * @param   {Store.commit}  context.commit
 * @param   {Store.getters} context.getters
 * @param   {object}        payload
 *
 * @returns {object}
 */
const createFeedback = async ({ commit, getters }, payload) => {
  const response = await ApiService.createFeedback(
    payload.styleId,
    payload.comment,
    payload.rating
  )
  const feedback = response.data
  const style = getters.getStyleById(payload.styleId)

  style.feedback.push(feedback)

  commit('updateStyle', style)

  return feedback
}

/**
 * @param   {Store}         context
 * @param   {Store.commit}  context.commit
 * @param   {Store.getters} context.getters
 * @param   {object}        payload
 *
 * @returns {object[]}
 */
const updateFeedback = async ({ commit, getters }, payload) => {
  const response = await ApiService.updateFeedback(
    payload.styleId,
    payload.feedbackId,
    payload.comment,
    payload.rating
  )
  const feedback = response.data
  const style = getters.getStyleById(payload.styleId)
  const index = style.feedback.findIndex(
    feedbackOld => feedbackOld.id === feedback.id
  )

  style.feedback.splice(index, 1, feedback)

  commit('updateStyle', style)

  return feedback
}

const actions = {
  createFeedback,
  updateFeedback
}

export default actions
